/* ==========================================================================
   Nootrópicos México v71.0 — Neural Portal runtime
   Marca navegación hacia productos sin retrasarla y activa la entrada visual
   en el destino. Compatible con prerender de Shopify/Chrome y bfcache.
   ========================================================================== */
(function () {
  "use strict";

  var STORAGE_KEY = "nmV71NeuralPortal";
  var MAX_AGE = 8000;
  var root = document.documentElement;
  var lastPointerMark = 0;
  var cleanupTimer = 0;

  function reducedMotion() {
    return Boolean(
      window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    );
  }

  function fineDesktopPointer() {
    return Boolean(
      window.matchMedia &&
        window.matchMedia("(min-width: 990px) and (hover: hover) and (pointer: fine)")
          .matches,
    );
  }

  function productLinkFrom(target) {
    var link = target && target.closest ? target.closest("a[href]") : null;
    if (!link || link.hasAttribute("download")) return null;
    if (link.target && link.target !== "_self") return null;
    if (link.closest("[data-no-neural-portal],.nm-product-lightbox")) return null;

    try {
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return null;
      if (!/^\/products\/[^/]+/.test(url.pathname)) return null;
      if (url.pathname === window.location.pathname) return null;
      return link;
    } catch (error) {
      return null;
    }
  }

  function saveMarker(event, forceCenter) {
    if (reducedMotion() || !fineDesktopPointer()) return;
    if (!productLinkFrom(event.target)) return;
    if (event.defaultPrevented) return;
    if (event.button !== undefined && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var usePointer = !forceCenter && event.clientX > 0 && event.clientY > 0;
    var x = usePointer ? (event.clientX / window.innerWidth) * 100 : 50;
    var y = usePointer ? (event.clientY / window.innerHeight) * 100 : 50;
    var marker = {
      t: Date.now(),
      x: Math.max(4, Math.min(96, x)),
      y: Math.max(5, Math.min(95, y)),
    };

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(marker));
      lastPointerMark = Date.now();
    } catch (error) {}
  }

  function readMarker() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var marker = JSON.parse(raw);
      if (!marker || Date.now() - Number(marker.t || 0) > MAX_AGE) return null;
      return marker;
    } catch (error) {
      return null;
    }
  }

  function clearMarker() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function finishPortal() {
    window.clearTimeout(cleanupTimer);
    cleanupTimer = window.setTimeout(function () {
      root.classList.remove("nm-v71-portal-incoming");
    }, 470);
  }

  function activateIncomingPortal() {
    var portal = document.getElementById("nmV71Portal");
    if (!portal) return;

    if (root.classList.contains("nm-v71-portal-incoming")) {
      finishPortal();
      return;
    }

    if (document.prerendering || reducedMotion() || !fineDesktopPointer()) return;
    var marker = readMarker();
    if (!marker) return;

    clearMarker();
    root.style.setProperty("--nm-v71-portal-x", Number(marker.x).toFixed(2) + "%");
    root.style.setProperty("--nm-v71-portal-y", Number(marker.y).toFixed(2) + "%");
    root.classList.add("nm-v71-portal-incoming");
    finishPortal();
  }

  document.addEventListener(
    "pointerdown",
    function (event) {
      saveMarker(event, false);
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "click",
    function (event) {
      if (Date.now() - lastPointerMark < 800) return;
      saveMarker(event, true);
    },
    { capture: true, passive: true },
  );

  document.addEventListener("visibilitychange", function () {
    root.classList.toggle("nm-v71-page-hidden", document.hidden);
    if (!document.hidden) activateIncomingPortal();
  });

  if ("prerendering" in document) {
    document.addEventListener("prerenderingchange", activateIncomingPortal, {
      once: true,
    });
  }

  window.addEventListener("pageshow", activateIncomingPortal);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", activateIncomingPortal, {
      once: true,
    });
  } else {
    activateIncomingPortal();
  }
})();

